const content = {
  padding: '0px',
  margin: '0px',
  height: '100px',
};

const picture = {
  float: 'left',
};

const info = {
  float: 'left',
  padding: '10px',
};

const subInfo = {

};

export default { content, picture, info, subInfo };



// WEBPACK FOOTER //
// ./src/scenes/UserSettings/components/UserModalHeader/style.js